import { render, staticRenderFns } from "./ServiceTable.vue?vue&type=template&id=54eadde6&scoped=true&"
import script from "./ServiceTable.vue?vue&type=script&lang=js&"
export * from "./ServiceTable.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTable.vue?vue&type=style&index=0&id=54eadde6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eadde6",
  null
  
)

export default component.exports